import { ModalDialog } from '@/scripts/interactive-defer/modal-dialog'
import { KlaviyoForm } from '@/scripts/interactive-defer/klaviyo-form'
import {
	getAttributeOrThrow,
	qsOptional,
	qsRequired, qsRequiredFromDocument,
} from '@/scripts/core/global'
import { getActiveOrAccessibilityElement, getSectionHTMLForResource } from '@/scripts/core/cart-functions'

export class WelcomePopup extends ModalDialog {
	static override htmlSelector = 'welcome-popup'
	klaviyoForm: KlaviyoForm
	openAfter: number
	cacheKey: string
	openers?: NodeListOf<HTMLButtonElement>
	demoMode: boolean
	requiresManualTrigger: boolean

	constructor() {
		super()
		this.requiresManualTrigger = this.hasAttribute('data-manual-trigger')
		this.klaviyoForm = qsRequired<KlaviyoForm>('klaviyo-form', this)
		this.openAfter =
			parseInt(getAttributeOrThrow('data-uc-open-after', this)) * 1000
		this.cacheKey = getAttributeOrThrow('data-uc-cache-key', this)
		this.demoMode =
			getAttributeOrThrow('data-uc-demo-mode', this) === 'true'

		this.initializePopup()
		// note: the code below should be used if the consentmo app is used for customer consent
		/*document.addEventListener("visitorConsentCollected", (event) => {
			const consentEvent = event as CustomEvent<ShopifyConsentAPIDetail>;
			if (consentEvent.detail.marketingAllowed && consentEvent.detail.analyticsAllowed) {
				this.initializePopup()
			}
		});*/
	}

	initializePopup() {
		if (this.isKeyDisabled() && !this.demoMode) return
		window.setTimeout(() => {
			if (!this.dataPrivacyIsOpen()) {
				this.show(getActiveOrAccessibilityElement())
				void window.Ucoast.mediaManager.loadAllInContainer(this)
			}

		}, this.openAfter)
	}

	dataPrivacyIsOpen() {
		const dataPrivacyModal =
			qsOptional('.cc-window') ??
			qsOptional('[aria-describedby="cookieconsent:desc"]')
		if (!dataPrivacyModal) return false
		return !dataPrivacyModal.classList.contains('cc-invisible')
	}

	override getHtmlSelector() {
		return WelcomePopup.htmlSelector
	}

	override connectedCallback() {
		this.initializePopup()
	}

	override show(opener: HTMLElement) {
		this.removeAttribute('style')
		window.setTimeout(() => {
			super.show(opener)
		}, 2)
	}

	override hide() {
		super.hide()
		this.disableKey()
	}

	isKeyDisabled() {
		const disabledKey = window.localStorage.getItem('disable_klaviyo')
		if (!disabledKey) return false
		return disabledKey === this.cacheKey
	}

	disableKey() {
		window.localStorage.setItem('disable_klaviyo', this.cacheKey)
	}
}

export class WaitlistPopup extends WelcomePopup {
	static override htmlSelector = 'waitlist-popup'
	dynamicContent: HTMLElement
	constructor() {
		super()
		this.dynamicContent = qsRequired('[data-dynamic-content]', this)
	}
	override disableKey() {}
	override initializePopup() {

	}
	async openPopup(url: string, variantId: number, opener: HTMLElement) {
		const fullUrl = `${url}?variant=${variantId}`
		const html = await getSectionHTMLForResource(fullUrl, 'dynamic-waitlist')
		if (!html) return
		const parser = new DOMParser()
		const doc = parser.parseFromString(html, 'text/html')
		const content = qsRequiredFromDocument('[data-dynamic-content]', doc)
		this.dynamicContent.innerHTML = content.innerHTML
		this.show(opener)
		void window.Ucoast.mediaManager.loadAllInContainer(this)
	}
}
